module.exports = __webpack_public_path__ + "img/muuq-fonts.3cbd3fc9.svg";